import VuiTypography from "components/VuiTypography";
import { Grid } from "@mui/material";
import { Card } from "@mui/material";
import { useState } from "react";

export function AppCodesChallengeCounter({ codesChallengeFilter, fetchPromoCodes }) {
  const [challengeId, setLabel] = useState(0);

  const handleFilter = (id) => {
    const newLabel = challengeId === id ? '' : id;
    setLabel(newLabel);
    fetchPromoCodes({ key: "challengeId", value: challengeId === id ? '' : id, clear: challengeId === id});
  };

  return (
    <Grid item xs={12} md={8} lg={8} xl={6}>
      <Grid container pl={"16px"} pr={"16px"} marginTop={0} spacing={2}>
        {codesChallengeFilter.map((item, index) => (
          <Grid item xs={4} key={item.challengeId}>
            <Card
              sx={{
                height: "85px",
                padding: "0px",
                cursor: "pointer",
                border: "solid 1px",
                borderColor: item.challengeId === challengeId ? "#007CFF" : "unset",
              }}
              onClick={() => handleFilter(item.challengeId)}
            >
              <VuiTypography
                sx={{
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  color: "#FFFFFF",
                  paddingTop: "6px",
                  textAlign: "center",
                }}
              >
                {item.title}
              </VuiTypography>
              <VuiTypography
                sx={{
                  fontSize: "24px",
                  fontWeight: "700",
                  lineHeight: "36px",
                  color: "#FFFFFF",
                  textAlign: "center",
                  paddingTop: "8px",
                }}
              >
                {item.counter}
              </VuiTypography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
